import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../../components/ui/table";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function AreasTable() {
  const token = localStorage.getItem("token");
  const [areas, setAreas] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchAreas = async () => {
    const response = await fetch(`${apiUrl}/areas`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    })
    const result = await response.json();
    console.log(result);

    if (result.success) {
      setAreas(result.areas);
    } else {
      setAreas([]);
    }
    // Fetch areas data from API or data source
  }
  useEffect(() => {
    fetchAreas();
  }, []);

  const handleRowClick = (area: any) => {
    navigate('/update-area', { state: { area } });
  }

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Area Name
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {areas.map((area) => (
            <TableRow key={area.acarea_id} className="cursor-pointer hover:bg-[#ffffa3]"  onClick={() => handleRowClick(area)}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{area.name}</span>
              </TableCell>
          </TableRow>))}
        </TableBody>
      </Table>
    </>
  )
}